import { render, staticRenderFns } from "./QuestionAlternatives.vue?vue&type=template&id=5d58e89a&"
import script from "./QuestionAlternatives.vue?vue&type=script&lang=js&"
export * from "./QuestionAlternatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports